/**
 * Currently can be used only for sites (laravel and nuxt)
 * example:
 * env.getPathToStaticAsset("/static/video/my_cool_video.mp4") -> https://my-cool-cdn.com/static/video/my_cool_video.mp4
 * @param {string} path_to_file path to your static asset
 * @param {string} env current environment. Possible values: client, server
 * @returns {string} Absolute path with cdn support(if needed)
 */
export default function getPathToStaticAsset(path_to_file, env = "client") {
  let cdn = "/";
  //client cdn detection
  if (env === "client") {
    if (window.APP_ENV?.urls?.cdn) {
      cdn = window.APP_ENV.urls.cdn;
    }
    // server nuxt cdn detection
  } else {
    if (process.env.CDN) {
      cdn = process.env.CDN;
    }
  }
  //normalize slashes
  const base_path = cdn.endsWith("/") ? cdn : cdn + "/"; // cdn always with slash
  path_to_file = path_to_file.startsWith("/") ? path_to_file.slice(1) : path_to_file; //asset path without slash

  return base_path + path_to_file;
}
